import {UserRole} from './UserRole';
import {BaseObject} from './BaseObject';

export class User extends BaseObject {
    id: number;
    name = '';
    surname = '';
    email: string;
    sendingEmail: string;
    password: string;
    phone: string;
    active: boolean;
    emailSignature: string;
    roleId: number = UserRole.ROLE_ADMIN_ID;
    role: UserRole = new UserRole();
}



// WEBPACK FOOTER //
// /app/src/model/Entities/User.ts